(function(){
var d=document;d.documentElement.classList.add('gz-js');
var reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var io=new IntersectionObserver(function(es){es.forEach(function(e){
if(!e.isIntersecting)return;
var el=e.target;el.classList.add('in');
el.querySelectorAll('[data-n]').forEach(count);
io.unobserve(el);});},{threshold:.2});
var fo=new IntersectionObserver(function(es){
var n=0;
es.forEach(function(e){
if(!e.isIntersecting)return;
var c=e.target,k=c.querySelector('.gz-fk');
fo.unobserve(c);
if(!k)return;
setTimeout(function(){k.checked=true;},reduced?0:n*380);
n++;});},{threshold:.6});
function count(n){var to=+n.dataset.n,s=null;
function st(t){if(!s)s=t;var k=Math.min((t-s)/900,1);n.textContent=Math.round(to*k);if(k<1)requestAnimationFrame(st);}
requestAnimationFrame(st);}
function once(el,k){if(el.dataset[k])return false;el.dataset[k]=1;return true;}
function init(){
d.querySelectorAll('.gz-rv,.gz-tb__b').forEach(function(el){if(once(el,'gzrv'))io.observe(el);});
d.querySelectorAll('.gz-fc').forEach(function(c){if(once(c,'gzfo'))fo.observe(c);});
d.querySelectorAll('[data-gz-tilt]').forEach(function(cfg){
if(!once(cfg,'gzt'))return;
var str=+cfg.dataset.gzStr||18,fl=cfg.dataset.gzFloat==='true',imgs;
try{imgs=d.querySelectorAll(cfg.dataset.gzTilt);}catch(e){return;}
imgs.forEach(function(img){
if(!once(img,'gztl'))return;
img.classList.add('gz-tl');if(fl)img.classList.add('gz-fl');
var box=img.parentElement;
box.addEventListener('pointermove',function(e){
if(e.pointerType!=='mouse')return;
var b=box.getBoundingClientRect(),x=(e.clientX-b.left)/b.width-.5,y=(e.clientY-b.top)/b.height-.5;
img.style.transform='perspective(900px) rotateY('+Math.round(x*str)+'deg) rotateX('+Math.round(-y*str*.7)+'deg)';});
box.addEventListener('pointerleave',function(){img.style.transform='';});});});
var sb=d.querySelector('.gz-sb');
if(sb&&once(sb,'gzsb')){
var t=d.querySelector('form[action*="/cart/add"]:not(.gz-form) [type="submit"]');
if(t)new IntersectionObserver(function(es){es.forEach(function(e){sb.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0);});}).observe(t);}
}
init();
setTimeout(init,1200);
d.addEventListener('shopify:section:load',init);
d.addEventListener('shopify:block:select',init);
})();